import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gpe-trash',
  templateUrl: './trash.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrashComponent { }
